export type LeadershipAction = 'newAppointment' | 'editDates' | 'removeRecord';

export interface LeadershipPeer {
  id: string;
  user_id?: string | null;
}

interface LeadershipSelfRemovalWarningInput {
  currentUserId?: string | null;
  incumbentUserId?: string | null;
  rowId: string;
  peers: LeadershipPeer[];
  action: LeadershipAction;
  nextUserId?: string | null;
  nextEndDate?: string | null;
}

export function shouldWarnLeadershipSelfRemoval(
  input: LeadershipSelfRemovalWarningInput
): boolean {
  const {
    currentUserId,
    incumbentUserId,
    rowId,
    peers,
    action,
    nextUserId,
    nextEndDate,
  } = input;

  const selfId = (currentUserId ?? '').trim();
  const incumbentId = (incumbentUserId ?? '').trim();
  if (!selfId || !incumbentId || selfId !== incumbentId) {
    return false;
  }

  const hasSelfElsewhere = peers.some((peer) => {
    if (!peer || peer.id === rowId) {
      return false;
    }
    return (peer.user_id ?? '').trim() === selfId;
  });

  if (hasSelfElsewhere) {
    return false;
  }

  if (action === 'removeRecord') {
    return true;
  }

  if (action === 'newAppointment') {
    const nextId = (nextUserId ?? '').trim();
    return nextId !== '' && nextId !== selfId;
  }

  if (action === 'editDates') {
    return (nextEndDate ?? '').trim() !== '';
  }

  return false;
}
